import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Button, Carte, Saisie } from "@/shared/ui";

export type OnboardingStep = "agency" | "done";

interface OnboardingChromeProps {
  step: OnboardingStep;
  onSignOut: () => void;
  children: ReactNode;
}

const STEPS: ReadonlyArray<OnboardingStep> = ["agency", "done"] as const;

export function OnboardingChrome({ step, onSignOut, children }: OnboardingChromeProps) {
  const { t } = useTranslation();
  const currentIdx = STEPS.indexOf(step);

  return (
    <div className="flex h-full items-center justify-center overflow-y-auto bg-canvas px-4 py-10">
      <div className="w-full max-w-[480px]">
        <Saisie.Etapes
          etapes={STEPS.map((s) => ({ cle: s, etiquette: t(`auth.onboarding.steps.${s}`) }))}
          courante={currentIdx}
        />
        <Carte remplissage="lg" className="mt-5 sm:p-9">
          {children}
          <Button variant="ghost" size="lg" onClick={onSignOut} className="mt-4 w-full">
            {t("auth.onboarding.signOut")}
          </Button>
        </Carte>
      </div>
    </div>
  );
}
